import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/console',
    name: 'settlement-console',
    component: () => import('./pages/ConsolePage.vue'),
    meta: { requiresAdminAuth: true, requiredRole: 'any', lifecycle: ['closed'] },
  },
];
